import gql from 'graphql-tag';

const accessoryTargetFields = gql`
  fragment accessoryTargetFields on AccessoryTarget {
    id
    accessoryId
    deviceId
    deviceType
    mask
    isProtected
    creationDate
  }
`;

export default accessoryTargetFields;
